import { Component, effect, inject, input, signal } from '@angular/core';
import { InputFieldComponent } from 'libs/shared/src/lib/components/input-field/input-field.component';
import { SvgIconsComponent } from 'libs/shared/src/lib/components/svg-icons/svg-icons.component';
import { FormGroup, FormControl, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { DynamicRouteHandlingService } from 'libs/shared/src/lib/services/dynamic-route-handling.service';
import { ProductListService } from '../../services/product-list.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { catchError, of, tap } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductList } from 'libs/home-building/src/lib/models/product.model';
import { Store } from '@ngrx/store';
import { AppState } from 'apps/cinari-erp-client/src/app/store/app.reducers';
import * as HomebuildingActions from '@zayan-erp/stores';

@Component({
  selector: 'lib-product-list-form',
  imports: [InputFieldComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './product-list-form.component.html'
})
export class ProductListFormComponent {
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #productListService = inject(ProductListService);
  #modalService = inject(NgbModal);
  #activatedRoute = inject(ActivatedRoute);
  #router = inject(Router);
  #store = inject(Store<AppState>);
  selectedProductListId = signal<string | null>(this.#activatedRoute.snapshot.paramMap.get('id'));

  constructor() {
    this.#dynamicRouteHandling.submitButton$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.onSubmit();
    });
  }
  productListForm = new FormGroup({
    name: new FormControl<string | null>(null, Validators.required),
    code: new FormControl<string | null>(null, Validators.required)
  });

  editRxResource = rxResourceFixed({
    params: () => ({ id: this.selectedProductListId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (params.id) {
        return this.#productListService.readProductListById(params.id).pipe(
          tap(productList => {
            this.editForm(productList);
          })
        );
      }
      return of(null);
    }
  });

  editForm(productList: ProductList) {
    this.productListForm.patchValue({
      name: productList.name,
      code: productList.code
    });
  }

  onSubmit(): void {
    if (!this.productListForm.valid) {
      this.productListForm.markAllAsTouched();
      return;
    }
    const productListData = {
      id: this.selectedProductListId()!,
      name: this.productListForm.value.name!,
      code: this.productListForm.value.code!
    };
    if (!this.selectedProductListId()) {
      this.#productListService.createProductList(productListData).subscribe({
        next: () => {
          this.productListForm.reset();
          this.#router.navigate([this.#activatedRoute.snapshot.data['returnRoute']]);
          this.#modalService.dismissAll();
          this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
          this.#store.dispatch(HomebuildingActions.loadProductList());
        }
      });
    } else {
      this.#productListService.updateProductList(productListData).subscribe({
        next: () => {
          this.productListForm.reset();
          this.#router.navigate([this.#activatedRoute.snapshot.data['returnRoute']]);
          this.#modalService.dismissAll();
          this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
          this.#store.dispatch(HomebuildingActions.loadProductList());
        }
      });
    }
  }
}
